import React, { useEffect, useState, useRef, Fragment, forwardRef, useImperativeHandle, UIEventHandler, useContext, useMemo } from "react";
import { Popover, Select, Dropdown, message, Tooltip, Tag } from "antd"
import { NavLink } from "react-router-dom"
import { getDaysBetweenDates, getMonthsBetweenDates, getMonthDays, k_dateType } from '../dashboard/components/utils'
import {
    k_dateWidth, handleDate, getDateWidth, useNodeStatus, getNodeStatusColor,
    isDefaultLineData, isMilestoneLineData, isPayLineData, k_renderLineType, getFormateDate,
    isRenderLineDefault, isRenderLineMilestone, isRenderLinePay, getDefaultColor,
    isExpenseLineData, isRenderLineExpense, k_renderNodeShape, getMoneyColor, getMoneyShape, getMoneyColorByStatus,
    parseProjectString, isSpecialLineData, isRenderLineSpecial
} from "./util"
import type {
    CalendarMonth, CalendarParams, RenderSubMilestone, RenderDateItem, RenderLine,
    RenderLineDefault, RenderLineMilestone, RenderLinePay,
    DefaultNode, MilestoneNode, PaymentNode, RenderFixedLine,
    RenderLineNode, DataSourceItem, MilestoneLineData, PayLineData, ExpenseLineData, RenderLineExpense, ExpenseNode,
    RenderNodeBase, SpecialLineNode, SpecialLineNodeData, SpecialLineData, RenderLineSpecial
} from "./util"
import clsx from "clsx";
import { parseTime } from '@/utils'
import Edit from "./edit";
import { ViewSvg, LinkSvg, BeaconSvg, TriangleSvg, ArrowBottomSvg, CloudSvg, PinSvg, MoneySvg } from "@/components/svgs"
import {
    getControlNodeLinesAPI, updateControlNodeStatusAPI, getProjectMultiplePaymentNodes, updateControlLineSortAPI,
    getProjectPaymentExpenseLinks, getTHPaymentNodesAPI, getProjectPaymentContractNodesApi, getTechnicalSpecialLineAPI,
    getProjectPaymentAllContractNodesApi
} from "@/services"
import { getMilestoneData } from '../milestone/index'
import { useRequest } from "ahooks"
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import LinkLines from "./linkLines"
import DDSFile from "./ddsFile"
import PopLineSelect from "./lineSelect"
import "./index.scss"
import { ProjectDetailContext } from "../constant"
import { k_milestoneStatus, getMilestoneStatusLabel } from '../milestone/edit'
import Axis from "./axis"
import PaymentExpenseLink from "./paymentExpenseLink"
import {k_permission} from "../project"
import { nanoid } from "nanoid";
import ImportMilestone from "./importMilestone"

//周/月-刻度显示天；季度-刻度显示周；年度-刻度显示月
// 周-天 100 月-天 40 季-周 140 年-月 200

const Gant = () => {
    const [messageApi, messageContextHolder] = message.useMessage();
    const params = useParams()
    const projectID = params.projectID || ""
    const { contacts = [], project, permissions } = useContext(ProjectDetailContext)
    const forbidEdit = useMemo(() => {
        return !(permissions && permissions.includes(k_permission.projectControlEdit))
    }, [permissions])
    const { data: nodeLines = [], refresh: updateControlNodeLines } = useRequest(async (projectID) => {
        const res = await getControlNodeLinesAPI(projectID)
        return res.map(item => {
            item.nodes.sort((a, b) => {
                if (a.date && !b.date) return -1
                if (!a.date && b.date) return 1
                if (a.date && b.date) {
                    return new Date(a.date).getTime() - new Date(b.date).getTime()
                }
                return 0
            })
            return {
                ...item,
                nodes: item.nodes.map(v => {
                    let isOutDate = false
                    // 2 已完成
                    if (v.status !== 1 && v.date) {
                        let nodeDate = new Date(v.date)
                        nodeDate.setHours(0, 0, 0, 0)
                        const curDate = new Date()
                        curDate.setHours(0, 0, 0, 0)
                        if (curDate > nodeDate) {
                            isOutDate = true
                        }
                    }
                    return {
                        ...v,
                        formatDate: getFormateDate(v.date),
                        isOutDate: isOutDate,
                        isCompleted: v.status === 1,
                        nodeLabel: v.nodeName || ""
                    }
                })
            }
        })
    }, {
        defaultParams: [projectID],
    })
    const { data: contactsPaymentNodes, loading: paylineLoading } = useRequest(async (projectID: string) => {
        const contractNodes = await getProjectPaymentContractNodesApi(projectID) 
        // const contractNodes = await getProjectPaymentAllContractNodesApi(projectID)
        // const res = await getProjectMultiplePaymentNodes(projectID, codes)
        const result: PayLineData[] = []
        const curDate = new Date()
        curDate.setHours(0, 0, 0, 0)
        const contractMap = new Map<string, PayLineData>()
        contractNodes.forEach(item => {
            if (item.salesContractCode) {
                let mapItem = contractMap.get(item.salesContractCode)

                if (!mapItem) {
                    mapItem = {
                        nodeType: k_renderLineType.payment,
                        contractCode: item.salesContractCode || "",
                        contractName: item.salesContractName || "",
                        status: item.status || "",
                        nodes: [{
                            ...item,
                            isDds: false,
                            isDraw: false,
                            nodeType: k_renderLineType.payment,
                            pos: "",
                            percent: 0,
                            formatDate: getFormateDate(item.date),
                            isOutDate: false,
                            isCompleted: item.status === "已收款",
                            nodeLabel: item.description || ""
                        }]
                    }
                } else {
                    mapItem.nodes.push({
                        ...item,
                        isDds: false,
                        isDraw: false,
                        nodeType: k_renderLineType.payment,
                        pos: "",
                        percent: 0,
                        formatDate: getFormateDate(item.date),
                        isOutDate: false,
                        isCompleted: item.status === "已收款",
                        nodeLabel: item.description || ""
                    })
                }
                
                contractMap.set(item.salesContractCode, mapItem)
            }
        })

        contractMap.forEach(item => {
            item.nodes.sort((a, b) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
            })
            result.push(item)
        })
        return result
    }, {
        // ready: contacts && contacts.length > 0,
        defaultParams: [projectID],
        refreshDeps: [projectID]
    });
    const { data: paymentExpenseLinks = [], refresh: refreshPaymentExpenseLinks } = useRequest(getProjectPaymentExpenseLinks, {
        defaultParams: [projectID],
    })
     
    const { data: expenseLinesDataOri = [] } = useRequest(async (projectID: string) => {
        const res = await getTHPaymentNodesAPI(projectID) || []
        const map = new Map<string, ExpenseLineData>()
        res.forEach(item => {
            const newItem: ExpenseNode = {
                ...item,
                date: item.predictpaytime,
                isDds: false,
                isDraw: false,
                nodeType: k_renderLineType.expense,
                isCompleted: true,
                pos: "",
                percent: 0,
                formatDate: getFormateDate(item.predictpaytime),
                isOutDate: false, // 已逾期
                nodeLabel: item.paymentcondition || ""
            }
            if (!map.has(item.purContractCode)) {
                map.set(item.purContractCode, {
                    purContractCode: item.purContractCode,
                    purContractName: item.purContractName,
                    paymentplancode: item.paymentplancode,
                    nodeType: k_renderLineType.expense,
                    nodes: [newItem]
                })
                return
            }
            map.get(item.purContractCode)?.nodes?.push(newItem)
        })
        return Array.from(map.values())
    }, {
        defaultParams: [projectID]
    })
    const { data: technicalSpecialLine } = useRequest(async (projectID: number | string) => {
        const res = await getTechnicalSpecialLineAPI(projectID) || []
        if(res.length === 0){
            return null
        }
        let link = ""
        const specialLine: SpecialLineNodeData[] = []
        res.forEach(item => {
            let nodePrefix = `${item.xtProjectcode}-${item.xtProjectname}${item.majorName ? `-${item.majorName}` : ""}`
            Object.keys(item).forEach(key => {
                if (key.endsWith("Time") && item[key]) {
                    const prefixKey = key.replace(/Time$/, "");
                    specialLine.push({
                        name: nodePrefix + (item[prefixKey + "TimeName"] || ""),
                        date: item[key] || "",
                    })
                }
            })
            if(item.subsidiaryCircleLink){
                link = item.subsidiaryCircleLink
            }
        })
        const nodes = specialLine.map(v => ({
            ...v,
            isCompleted: false,
            isOutDate: false,
            isDraw: false,
            isDds: false,
            nodeType: k_renderLineType.special,
            nodeLabel: v.name || "",
            formatDate: getFormateDate(v.date),
            pos: "",
            percent: 0
        }))
        
        return {
            uuid: nanoid(),
            nodeType: 'special' as const,
            lineName: "外协交圈",
            link: link,
            nodes: nodes
        }
    }, {
        defaultParams: [projectID],
    })
    const expenseLinesData = useMemo(() => {
        if (!expenseLinesDataOri || expenseLinesDataOri.length === 0) {
            return []
        }
        if (!paymentExpenseLinks || paymentExpenseLinks.length === 0) {
            return expenseLinesDataOri.map(item => ({
                ...item,
                nodes: item.nodes.map(node => ({
                    ...node,
                    links: undefined
                }))
            }))
        }
        if (!contactsPaymentNodes || contactsPaymentNodes.length === 0) {
            return expenseLinesDataOri.map(item => ({
                ...item,
                nodes: item.nodes.map(node => ({
                    ...node,
                    links: undefined
                }))
            }))
        }
        return expenseLinesDataOri.map(item => ({
            ...item,
            nodes: item.nodes.map(node => {
                const links = paymentExpenseLinks.filter(v =>
                    v.fromContractCode === item.purContractCode
                    && v.fromCode === node.paymentplancode).map(link => {
                        const contact = contactsPaymentNodes.find(v => v.contractCode === link.toContractCode)
                        const contactNode = contact?.nodes?.find(v => v.pmCode === link.toCode)
                        return {
                            ...link,
                            label: contact && contactNode ? `收款-${contact.contractName}-${contactNode.description}` : ""
                        }
                    })
                return {
                    ...node,
                    links
                }
            })
        }))
    }, [expenseLinesDataOri, paymentExpenseLinks, contactsPaymentNodes])
    // const { data: milestones = [], loading: milestoneLoading } = useRequest(getMilestoneData, {
    //     defaultParams: [projectID]
    // });
    
    const { allStatus, getStatusLabel } = useNodeStatus()

    const gantEl = useRef<HTMLDivElement>(null)

    const [dateType, setDateType] = useState(k_dateType.all)
    const todayPosition = useRef({
        show: false,
        left: 0,
        leftStr: "0%"
    })
    const [calendar, setCalendar] = useState<CalendarParams>({
        days: [],  // 所有天的集合
        months: [],
        weeks: [],
        years: [],
        cols: [],
        start: 0,
        end: 0,
        allStart: 0,
        allEnd: 0,
        totalDays: 0
    })
    const [dateRange, setDateRange] = useState<number[] | null>(null)
    const [renderList, setRenderList] = useState<RenderLine[]>([])
    const getTimeLabelByScrollLeft = (scrollLeft: number) => {
        if (dateType === k_dateType.all || (dateType === k_dateType.year && calendar.months.length < 12)){
            return null
        }
        let index = Math.floor(scrollLeft / getDateWidth(dateType))
        index = Math.max(0, index)
        if (dateType === k_dateType.season) {
            let date = new Date(calendar.start)
            date.setDate(date.getDate() + index * 7)
            return `${date.getFullYear()}年${date.getMonth() + 1}月`
        }
        if (dateType === k_dateType.year) {
            let date = new Date(calendar.start)
            date.setMonth(date.getMonth() + index)
            return `${date.getFullYear()}年`
        }
        let date = new Date(calendar.start)
        date.setDate(date.getDate() + index)
        return `${date.getFullYear()}年${date.getMonth() + 1}月`
    }
    const getPositionByTime = (time: Date, calendarOption?: CalendarParams) => {
        const option = calendarOption || calendar
        const timeMs = time.getTime()
        if (timeMs > option.end || timeMs < option.start) {
            return {
                pos: 0,
                percent: 0
            }
        }
        const startDate = new Date(option.start)
        const lstart = getDaysBetweenDates(startDate, time)

        let left = 0, midWidth = 0
        let pos = 0
        switch (dateType) {
            case k_dateType.week:
                left = lstart * k_dateWidth.week
                midWidth = k_dateWidth.week / 2
                pos = left + midWidth
                break
            case k_dateType.month:
                left = lstart * k_dateWidth.month
                midWidth = k_dateWidth.month / 2
                pos = left + midWidth
                break
            case k_dateType.season:
                left = (lstart / 7) * k_dateWidth.season
                pos = left + midWidth
                break
            case k_dateType.year:
                const startMonth = getMonthsBetweenDates(time, startDate)
                const startDays = time.getDate() - 1
                const startMonthDays = getMonthDays(time)

                const startLeft = (startMonth + startDays / startMonthDays) * k_dateWidth.year
                left = startLeft
                pos = left + midWidth
                break
            case k_dateType.all:
                pos = lstart / option.totalDays
                return {
                    pos: pos * option.contentW!,
                    percent: lstart / option.totalDays
                }
            default:
                break
        }
        return {
            pos: pos,
            percent: pos / option.contentW!
        }
    }
    const handleRenderLineItem = (item: DataSourceItem, type: string, newcalendar: CalendarParams) => {
        let itemMinDate: number | undefined
        let itemMaxDate: number | undefined
        let itemMaxCompletedDate: number | undefined
        const minDate = newcalendar.start
        const maxDate = newcalendar.end
        // 使用类型断言来解决filter方法的类型兼容性问题
        const filterNodes: RenderLineNode[] = (item.nodes as RenderLineNode[]).filter(v => {
            if(v.date){
                const time = new Date(v.date).getTime()
                return time >= minDate && time <= maxDate
            }
            return false
        })
        const mapNodes = new Map<string, RenderNodeBase>()
        filterNodes.forEach(v => {
            if (v.date) {
                const time = new Date(v.date).getTime()
                if (!itemMinDate) {
                    itemMinDate = time
                } else {
                    itemMinDate = Math.min(itemMinDate, time)
                }
                if (!itemMaxDate) {
                    itemMaxDate = time
                } else {
                    itemMaxDate = Math.max(itemMaxDate, time)
                }
                
                if (v.isCompleted) {
                    if (!itemMaxCompletedDate) {
                        itemMaxCompletedDate = time
                    } else {
                        itemMaxCompletedDate = Math.max(itemMaxCompletedDate, time)
                    }
                }

            }
            let pos = 0
            if (v.date) {
                pos = getPositionByTime(new Date(v.date), newcalendar).percent
            }
            let shape = k_renderNodeShape.circle
            

            if (isPayLineData(item) || isExpenseLineData(item)) {
                shape = getMoneyShape((v as PaymentNode | ExpenseNode).status as string)
            } else {
                if (v.isCompleted) {
                    if (v.isDraw) {
                        shape = k_renderNodeShape.paintDoubleCircle
                    } else {
                        shape = k_renderNodeShape.paintCircle
                    }
                } else if (v.isOutDate) {
                    shape = k_renderNodeShape.triangle
                } else if (v.isDraw) {
                    shape = k_renderNodeShape.doubleCircle
                }
            }

            if (mapNodes.has(v.date)) {
                const mapNode = mapNodes.get(v.date)!
                shape = shape < mapNode.shape ? shape : mapNode.shape
                mapNodes.set(v.date, {...mapNode, shape: shape, children: [...mapNode.children, v]})
            } else {
                mapNodes.set(v.date, {
                    uuid: nanoid(),
                    pos: pos * 100 + "%",
                    percent: pos,
                    shape: shape,
                    children: [v]
                })
            }
        })
        let posNodes: RenderNodeBase[] = Array.from(mapNodes.values())

        const left = itemMinDate ? getPositionByTime(new Date(itemMinDate!), newcalendar) : { percent: 0 }
        const right = itemMaxDate ? getPositionByTime(new Date(itemMaxDate!), newcalendar) : { percent: 0 }
        let completedWidth: string | number = 0
        if (itemMaxCompletedDate) {
            const completedRight = getPositionByTime(new Date(itemMaxCompletedDate!), newcalendar)
            completedWidth = (completedRight.percent - left.percent) * 100 + "%"
        }
        let lineID: number | string = 0
        let lineName: string = ""
        if (isDefaultLineData(item) || isMilestoneLineData(item)){
            lineID = item.ID
            lineName = item.lineName
        } else if(isPayLineData(item)){
            lineID = item.contractCode
            lineName = `收款-${item.contractName}`
        } else if (isExpenseLineData(item)) {
            lineID = item.purContractCode
            lineName = `费用-${item.purContractName}`
        } else if (isSpecialLineData(item)) {
            lineID = item.uuid
            lineName = item.lineName
        }
        return {
            ...item,
            uuid: nanoid(),
            nodeType: type,
            lineID: lineID,
            lineName: lineName,
            leftPos: left.percent * 100 + "%",
            width: (right.percent - left.percent) * 100 + "%",
            completedWidth: completedWidth,
            renderNodes: posNodes
        }
    }
    const handleRenaderData = (newCalender: CalendarParams) => {
        const minDate = newCalender.start
        const maxDate = newCalender.end
        const pos = getPositionByTime(new Date(), newCalender)
        const curDate = new Date()
        curDate.setHours(0, 0, 0)
        const curTime = curDate.getTime()
        todayPosition.current = {
            show: curTime >= minDate && curTime <= maxDate,
            left: pos.pos,
            leftStr: pos.percent * 100 + "%"
        }

        nodeLines.sort((a, b) => {
            // 把 isMainMilestone 和 isMilestone 都为 true 的项排在最后
            const aIsMilestone = a.isMainMilestone && a.isMilestone ? 1 : 0;
            const bIsMilestone = b.isMainMilestone && b.isMilestone ? 1 : 0;
            if (aIsMilestone !== bIsMilestone) {
                return aIsMilestone - bIsMilestone;
            }
            return a.sort - b.sort;
        })

        const newList: RenderLine[] = []
        if (technicalSpecialLine) {
            const specialLine = handleRenderLineItem(technicalSpecialLine, k_renderLineType.special, newCalender) as RenderLine
            newList.push(specialLine)
        }


        const defaultLines = nodeLines.map(item => {
            let type = k_renderLineType.default as string
            if(item.isMainMilestone){
                type = k_renderLineType.milestone
            } else if (item.isMilestone) {
                type = k_renderLineType.importMilestone
            }
            return handleRenderLineItem(item as DataSourceItem, type, newCalender) as RenderLine
        })
        newList.push(...defaultLines)
        

        // 不显示里程碑
        // if (milestones.length > 0 && project?.profile?.typeId !== 1) {
        //     const milestoneData: MilestoneLineData = {
        //         nodeType: k_renderLineType.milestone,
        //         nodes: milestones.map(v => ({
        //             ...v,
        //             isDds: false,
        //             isDraw: false,
        //             nodeType: k_renderLineType.milestone,
        //             isCompleted: v.status === k_milestoneStatus.finished,
        //             pos: "",
        //             percent: 0,
        //             formatDate: getFormateDate(v.date),
        //             isOutDate: v.outDate && v.status !== k_milestoneStatus.finished, // 已逾期
        //             nodeLabel: v.milestoneName || ""
        //         }))
        //     }
        //     const milestoneLine = handleRenderLineItem(milestoneData, k_renderLineType.milestone, newCalender) as RenderLineMilestone
        //     newList.push(milestoneLine)
        // }
        const payLines = (contactsPaymentNodes || []).map(v => {
            return handleRenderLineItem(v, k_renderLineType.payment, newCalender) as RenderLinePay
        })
        newList.push(...payLines)
        if (expenseLinesData.length > 0) {
            const expenseLines = (expenseLinesData || []).map(v => {
                return handleRenderLineItem(v, k_renderLineType.expense, newCalender) as RenderLineExpense
            })
            newList.push(...expenseLines)
        }
        setRenderList(newList)
    }
    const handleCalendar = () => {
        let minDate: number | undefined
        let maxDate: number | undefined
        let isRangeVal = false
        if (dateType === k_dateType.all && calendar.allStart > 0 && calendar.allEnd > 0 && dateRange && dateRange.length === 2) {
            minDate = dateRange[0]
            maxDate = dateRange[1]
            isRangeVal = true
        } else {
            nodeLines.forEach(v => {
                v.nodes.forEach(v => {
                    if (v.date) {
                        const time = new Date(v.date).getTime()
                        if (!minDate) {
                            minDate = time
                        } else {
                            minDate = Math.min(minDate, time)
                        }
                        if (!maxDate) {
                            maxDate = time
                        } else {
                            maxDate = Math.max(maxDate, time)
                        }
                    }
                })
            })
            // milestones.forEach(v => {
            //     if (v.date) {
            //         const time = new Date(v.date).getTime()
            //         if (!minDate) {
            //             minDate = time
            //         } else {
            //             minDate = Math.min(minDate, time)
            //         }
            //         if (!maxDate) {
            //             maxDate = time
            //         } else {
            //             maxDate = Math.max(maxDate, time)
            //         }
            //     }
            // })
            if (expenseLinesData){
                expenseLinesData.forEach(item => {
                    item.nodes.forEach(v => {
                        if (v.predictpaytime) {
                            const time = new Date(v.predictpaytime).getTime()
                            if (!minDate) {
                                minDate = time
                            } else {
                                minDate = Math.min(minDate, time)
                            }
                            if (!maxDate) {
                                maxDate = time
                            } else {
                                maxDate = Math.max(maxDate, time)
                            }
                        }
                    })
                })
            }
            if (contactsPaymentNodes) {
                contactsPaymentNodes.forEach(v => {
                    v.nodes.forEach(payNode => {
                        if (payNode.date) {
                            const time = new Date(payNode.date).getTime()
                            if (!minDate) {
                                minDate = time
                            } else {
                                minDate = Math.min(minDate, time)
                            }
                            if (!maxDate) {
                                maxDate = time
                            } else {
                                maxDate = Math.max(maxDate, time)
                            }
                        }
                    })
                })
            }
            if (technicalSpecialLine && technicalSpecialLine.nodes) {
                technicalSpecialLine.nodes.forEach(item => {
                    if (item.date) {
                        const time = new Date(item.date).getTime()
                        if (!minDate) {
                            minDate = time
                        } else {
                            minDate = Math.min(minDate, time)
                        }
                        if (!maxDate) {
                            maxDate = time
                        } else {
                            maxDate = Math.max(maxDate, time)
                        }
                    }
                })
            }

            let initStart = new Date()
            if (!minDate) {
                minDate = initStart.getTime()
            }
            if (!maxDate) {
                const end = new Date(minDate)
                end.setFullYear(end.getFullYear() + 1)
                maxDate = end.getTime()
            }
        }

        

        const totalDays = getDaysBetweenDates(new Date(minDate), new Date(maxDate))

        const date = handleDate(dateType, new Date(minDate), new Date(maxDate))
        let cols: string[] = []
        let contentW = 0
        switch (dateType) {
            case k_dateType.week:
            case k_dateType.month:
                cols = date.days.map(v => `${v}`)
                contentW = cols.length * getDateWidth(dateType)
                break
            case k_dateType.season:
                cols = date.weeks.map(v => {
                    if (v.start === v.end) return `${v.start}日`
                    return `${v.start}日 - ${v.end}日`
                })
                contentW = cols.length * getDateWidth(dateType)
                break
            case k_dateType.year:
                contentW = date.months.length * getDateWidth(dateType)
                break
        }
        const newData: CalendarParams = {
            ...date,
            cols,
            start: minDate,
            end: maxDate,
            allStart: calendar.allStart,
            allEnd: calendar.allEnd,
            contentW,
            totalDays
        }
        if(!isRangeVal){
            newData.allStart = minDate
            newData.allEnd = maxDate
        }
        return newData
    }
    useEffect(() => {
        const newCalender =  handleCalendar()
        setCalendar(newCalender)
        handleRenaderData(newCalender)
    }, [dateType, nodeLines, contactsPaymentNodes, expenseLinesData, dateRange])

    useEffect(() => {
        scrollToToday()
    }, [dateType])

    const [scrollTimeLabel, setScrollTimeLabel] = useState("")
    const onGantScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollLeft } = e.currentTarget;
        const scrollTimeLabel = getTimeLabelByScrollLeft(scrollLeft)
        setScrollTimeLabel(scrollTimeLabel || "")
    }
    const scrollToToday = () => {
        if (!todayPosition.current.show || !gantEl.current || dateType === k_dateType.all) return
        const boxWidth = gantEl.current.clientWidth
        const mid = todayPosition.current.left - boxWidth / 2
        const left = mid < 0 ? todayPosition.current.left : mid
        gantEl.current.scrollTo({
            left: left
        })
    }
    const scrollToDate = (time: Date) => {
        if (!gantEl.current || dateType === k_dateType.all) return
        const timePos = getPositionByTime(time)
        const boxWidth = gantEl.current.clientWidth
        const mid = timePos.pos - boxWidth / 2
        const left = mid < 0 ? timePos.pos : mid
        gantEl.current.scrollTo({
            left: left
        })
    }

    const [hideLabel, setHideLabel] = useState(false)
    const [hideLinks, setHideLinks] = useState(false)
    const [editVisible, setEditVisible] = useState(false)

    const isHideMonthRow = dateType === k_dateType.all && calendar.months.length >= 12
    const topHeight = isHideMonthRow ? 35 : 70

   

    const { run: updateControlNodeStatus } = useRequest(updateControlNodeStatusAPI, {
        manual: true,
        onSuccess: (data) => {
            updateControlNodeLines()
        },
        onError(e, params) {
            messageApi.error(e as any)
        },
    })
    
    // 定义必要的状态变量 - 合并重复定义
    const [ddsVisible, setDdsVisible] = useState<boolean>(false);
    const curDdsNode = useRef<any>();
    const [defaultEditLineID, setDefaultEditLineID] = useState<number | string | null>()
    const onShowEditModal = (item: RenderLine | null = null) => {
        if (item && item.nodeType === k_renderLineType.special) return
        if (item && (item.nodeType === k_renderLineType.payment || item.nodeType === k_renderLineType.expense)) {
            setDefaultEditLineID(item.lineID);
            setPayExpenseLinkVisible(true)
            return
        }

        let itemID = item ? item.lineID : null
        if (item && isRenderLineDefault(item)) {
            itemID = item.ID
        }
        setDefaultEditLineID(itemID);
        setEditVisible(true);
    }

    // 勾选显示指定任务线
    const [checkedRenderList, setCheckedRenderList] = useState<RenderLine[]>([])
    const [checkedIDs, setCheckedIDs] = useState<(number | string)[]>([]);
    const isChangeCheckedIDs = useRef<boolean>(false);
    const onCheckLineChange = (v: (number | string)[]) => {
        isChangeCheckedIDs.current = true
        setCheckedIDs(v)
        setCheckedRenderList(renderList.filter(item=>v.includes(item.lineID)))
    }
    useEffect(() => {
        if (isChangeCheckedIDs.current) return
        setCheckedIDs(renderList.map(item => item.lineID))
    }, [renderList])
    useEffect(() => {
        setCheckedRenderList(renderList.filter(v=> checkedIDs.includes(v.lineID)))
    }, [renderList, checkedIDs])

    const onShowDDSFileModalByNodeID = (nodeID: number) => {
        if (!nodeID) return
        let node: DefaultNode | null = null
        renderList.filter(v=>v.nodeType === k_renderLineType.default).forEach(line => {
            let findNode = (line as RenderLineDefault).nodes.find(v => (v as DefaultNode).ID === nodeID)
            if (findNode) {
                node = findNode as DefaultNode
            }
        })
        if (node) {
            onShowDDSFileModal(node)
        }
    }
    const onShowDDSFileModal = (node: DefaultNode) => {
        curDdsNode.current = node;
        setDdsVisible(true);
    }
    const onDateRangeChange = (v: number[]) => {
        if (v.length !== 2) return
        let [start, end] = v
        const sortArr = start < end ? [start, end] : [end, start];
        setDateRange(sortArr)
    }

    const [payExpenseLinkVisible, setPayExpenseLinkVisible] = useState<boolean>(false);
    const updatePaymentExpenseLink = () => {
        
    }
    const renderMoneyNodePoint = (node: RenderNodeBase, item: RenderLine) => {
        let color = getDefaultColor(item.nodeType)
        if (node.shape !== k_renderNodeShape.moneyUnpaid) {
            color = getMoneyColor(node.shape, color)
            return (
                <div style={{ color: color, borderColor: color }} className="line-node-point w-[14px] h-[14px] text-[10px] flex items-center justify-center rounded-full border-2 bg-white border-solid">
                    <MoneySvg />
                </div>
            )
        }
        return (
            <div className="line-node-point w-[14px] h-[14px] rounded-full" style={{ backgroundColor: color }}></div>
        )
    }
    const renderNodePoint = (node: RenderNodeBase, item: RenderLine) => {
        if (item.nodeType === k_renderLineType.expense || item.nodeType === k_renderLineType.payment) return renderMoneyNodePoint(node, item)
        let color = getDefaultColor(item.nodeType)
        if (isRenderLineDefault(item)) {
            color = item.colorValue || color
        }
        if (node.shape === k_renderNodeShape.triangle) {
            return (
                <div className="line-node-point relative text-[20px] inline-flex" style={{ color: color }}>
                    <TriangleSvg />
                    <div className="absolute left-0 top-0 w-full h-full flex items-center justify-center text-white text-[10px]">
                        <BeaconSvg />
                    </div>
                </div>
            )
        }
        if(node.shape === k_renderNodeShape.paintDoubleCircle){
            return <div className="line-node-point p-px rounded-full border-2 bg-white border-solid" style={{ borderColor: color }}>
                <div className="w-[14px] h-[14px] rounded-full border border-solid" style={{ backgroundColor: color, borderColor: color }}></div>
            </div>
        }
        if(node.shape === k_renderNodeShape.paintCircle){
            return <div className="line-node-point w-[14px] h-[14px] rounded-full" style={{ backgroundColor: color }}></div>
        }
        if(node.shape === k_renderNodeShape.doubleCircle){
            return <div className="line-node-point p-px rounded-full border-2 bg-white border-solid border-gray-400">
                <div className="w-[14px] h-[14px] rounded-full border border-solid border-gray-400" style={{ backgroundColor: "#ffffff" }}></div>
            </div>
        }
        return <div className="line-node-point w-[14px] h-[14px] rounded-full border-2 bg-white border-gray-400 border-solid"></div>
    }

    const renderNodePopover = (node: RenderNodeBase, line: RenderLine) => {
        const onNodeStatusChange = (val: number, child: RenderLineNode) => {
            if (!isRenderLineDefault(line) || forbidEdit) return
            updateControlNodeStatus((child as DefaultNode).ID, val);
        };
        
        const onShowDdsFileModal = (child: RenderLineNode) => {
            if(!isRenderLineDefault(line) || forbidEdit) return
            onShowDDSFileModal(child as DefaultNode)
        };

        const getNodeStatusLabel = (status?: number | string) => {
            if (isRenderLineDefault(line)) {
                return getStatusLabel(status as number)
            }
            if (isRenderLineMilestone(line)) {
                return getMilestoneStatusLabel(status as number)
            }
            if (isRenderLinePay(line)) {
                return status as string
            }
            return ""
        }

        if (line.nodeType === k_renderLineType.expense) {
            return (
                <table className="text-xs">
                    <tbody>
                        <tr className="text-left border-b">
                            <th className="px-2 py-1 text-sm">合同名称</th>
                            <th className="px-2 py-1 text-sm">时间</th>
                            <th className="px-2 py-1 text-sm">状态</th>
                            <th className="px-2 py-1 text-sm">付款描述</th>
                            <th className="px-2 py-1 text-sm">关联节点</th>
                        </tr>
                        {node.children.map((child, index)=>(
                            <tr key={index} className="text-left border-b">
                                <td className="px-2 py-1 max-w-[200px]">{(child as ExpenseNode).purContractName}</td>
                                <td className="px-2 py-1">{(child as ExpenseNode).predictpaytime}</td>
                                <td className="px-2 py-1" style={{ color: getMoneyColorByStatus((child as ExpenseNode).status as string) }}>{(child as ExpenseNode).status}</td>
                                <td className="px-2 py-1 max-w-[200px]">{(child as ExpenseNode).paymentcondition}</td>
                                <td className="px-2 py-1 max-w-[200px] flex flex-wrap gap-1">{(child as ExpenseNode).links?.map((v, i) => (
                                    <div key={i} className="text-xs bg-gray-200 rounded-md text-gray-700 p-1 break-all">{v.label}</div>
                                ))}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )
        }
        let isMilestone = line.nodeType === k_renderLineType.milestone || line.nodeType === k_renderLineType.importMilestone
        if (line.nodeType === k_renderLineType.default || isMilestone) {
            return (
                <table className="text-xs">
                    <tbody>
                        <tr className="text-left border-b">
                            <th className="px-2 py-1 text-sm">节点名称</th>
                            <th className="px-2 py-1 text-sm">状态</th>
                            <th className="px-2 py-1 text-sm">截止时间</th>
                            <th className="px-2 py-1 text-sm">负责人</th>
                            <th className="px-2 py-1 text-sm">关联节点</th>
                            <th className="px-2 py-1 text-sm">操作</th>
                        </tr>
                        {node.children.map((child, index) => (
                            <tr key={index} className="text-left border-b">
                                <td className="px-2 py-1 max-w-[200px]">{(child as DefaultNode).nodeLabel}</td>
                                <td className="px-2 py-1">
                                    {forbidEdit || isMilestone ? (
                                        <span>
                                            {getNodeStatusLabel((child as DefaultNode | MilestoneNode).status)}
                                        </span>
                                    ) : (
                                        <Select
                                            options={allStatus?.map(v => ({ label: <span style={{ color: getNodeStatusColor(v.name) }}>{v.name}</span>, value: v.nodeStatus })) || []}
                                                value={(child as DefaultNode | MilestoneNode).status as number || 0}
                                            onChange={(val) => onNodeStatusChange(val, child)}
                                            className="w-[100px]"
                                            placeholder="请选择"
                                        />
                                    )}
                                </td>
                                <td className="px-2 py-1">{child.formatDate}</td>
                                <td className="px-2 py-1">{(line as RenderLineDefault).assignUser?.lastname || '-'}</td>
                                <td className="px-2 py-1 max-w-[200px] flex flex-wrap gap-1">
                                    {(child as DefaultNode).nodes?.map((v, i) => (
                                        <div key={i} className="text-xs bg-gray-200 rounded-md text-gray-700 p-1 break-all">{v.nodeName}</div>
                                    ))}
                                    {(child as DefaultNode).pmNodes?.map((v, i) => (
                                        <div key={i} className="text-xs bg-gray-200 rounded-md text-gray-700 p-1 break-all">{v.nodeName}</div>
                                    ))}
                                </td>
                                <td className="px-2 py-1">
                                    {(child as DefaultNode).isDds && (
                                        <div className="flex items-center">
                                            <span className="text-blue-500 cursor-pointer" onClick={() => onShowDdsFileModal(child)}>附件管理</span>
                                            {(child as DefaultNode).nodeFiles && (child as DefaultNode).nodeFiles!.length > 0 && (
                                                <span className="text-black ml-1 text-[14px]">
                                                    <CloudSvg />
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )
        }
        if(line.nodeType === k_renderLineType.special){
            return <table className="text-xs">
                <tbody>
                    <tr className="text-left border-b">
                        <th className="px-2 py-1 text-sm">节点名称</th>
                        <th className="px-2 py-1 text-sm">关联链接</th>
                        <th className="px-2 py-1 text-sm">时间</th>
                    </tr>
                    {node.children.map((child, index) => (
                        <tr key={index} className="text-left border-b">
                            <td className="px-2 py-1 max-w-[200px] break-all">{child.nodeLabel}</td>
                            <td className="px-2 py-1 max-w-[200px]">
                                {(line as RenderLineSpecial).link && (
                                    <a href={(line as RenderLineSpecial).link} target="_blank" rel="noopener noreferrer" className="text-blue-500 cursor-pointer underline">
                                        目录
                                    </a>
                                )}
                            </td>
                            <td className="px-2 py-1">{child.formatDate}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        }
        
        return (
            <table className="text-xs">
                <tbody>
                    <tr className="text-left border-b">
                        <th className="px-2 py-1 text-sm">节点名称</th>
                        <th className="px-2 py-1 text-sm">状态</th>
                        <th className="px-2 py-1 text-sm">截止时间</th>
                    </tr>
                    {node.children.map((child, index) => (
                        <tr key={index} className="text-left border-b">
                            <td className="px-2 py-1 max-w-[200px]">{child.nodeLabel}</td>
                            <td className="px-2 py-1">
                                {line.nodeType === k_renderLineType.payment ? (
                                    <span style={{color: getMoneyColorByStatus(child.status as string)}}>
                                        {getNodeStatusLabel(child.status!)}
                                    </span>
                                ): (
                                    <span className={child.isOutDate ? "text-red-500" : "text-gray-800"}>
                                        {child.isOutDate ? "已逾期" : getNodeStatusLabel(child.status!)}
                                    </span>   
                                )}
                                
                            </td>
                            <td className="px-2 py-1">{child.formatDate}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };
    const renderLine = (v: RenderLine, index: number) => {
        let color = getDefaultColor(v.nodeType)
        let key: number | string = ""
        if (isRenderLineDefault(v)) {
            color = v.colorValue || color
            key = v.ID || ""
        }else if(isRenderLineMilestone(v)){
            key = "milestone"
        }else if(isRenderLinePay(v)){
            key = (v as RenderLinePay).lineID || ""
        } else if (isRenderLineExpense(v)) {
            key = (v as RenderLineExpense).lineID || ""
        } else if (isRenderLineSpecial(v)) {
            key = (v as RenderLineSpecial).lineID || ""
        }
        const isMoneyLine = v.nodeType === k_renderLineType.expense || v.nodeType === k_renderLineType.payment
        let bgcolor = isMoneyLine ? "bg-orange-50" : "bg-red-50"
        if (v.nodeType === k_renderLineType.milestone) {
            bgcolor = "bg-green-50"
        }
        return <div key={key} className={clsx("px-[20px]", bgcolor)} onDoubleClick={() => onShowEditModal(v)}>
            <div className="relative h-[100px] w-full">
                <div className="absolute top-1/2 -translate-y-1/2 bg-[#aaa] h-[5px] rounded-full" style={{ left: v.leftPos, width: v.width }}></div>
                <div className="absolute top-1/2 -translate-y-1/2 h-[5px] rounded-full z-1" style={{ left: v.leftPos, width: v.completedWidth, backgroundColor: color }}></div>
                {v.renderNodes.map((node, node_i) => {
                    // 直接使用组合key
                    const nodeKey = node.uuid;
                    return (
                        <Popover key={nodeKey} content={() => renderNodePopover(node, v)} title={null}>
                            <div style={{ left: node.pos! }}
                                className={clsx("absolute z-10 group flex hover:z-50 top-1/2 -translate-y-1/2 node-point-box",
                                    node.shape === k_renderNodeShape.triangle ? "translate-x-[-10px] z-20" : "translate-x-[-7px]")}>
                                {renderNodePoint(node, v)}
                                {!hideLabel && (
                                    <div className={
                                        clsx("absolute text-xs rounded-md group-hover:shadow-eq-lg p-1",
                                            node_i === 0 ? "left-0" : node_i === v.renderNodes.length - 1 ? "right-0" : "left-1/2 -translate-x-1/2",
                                            node.shape === k_renderNodeShape.triangle && "z-20",
                                            node_i % 2 === 0 ? "top-full" : "top-0 -translate-y-full"
                                        )}
                                        style={{
                                            color: node.shape === k_renderNodeShape.triangle ? "#ffffff" : color,
                                            backgroundColor: node.shape === k_renderNodeShape.triangle ? color : "#ffffff",
                                        }}
                                    >
                                        {node.children.map((child, index) => (
                                            <div key={index} className="text-[12px] whitespace-nowrap overflow-hidden text-ellipsis max-w-[100px] text-center">{child.nodeLabel}</div>
                                        ))}
                                        {/* <div className="two-line-clamp min-w-[60px] max-w-[100px] whitespace-normal text-center">{nodeLabel}</div> */}
                                    </div>
                                )}
                            </div>
                        </Popover>
                    )
                })}
            </div>
        </div>
    }

    const renderLineName = (v: RenderLine, i: number) => {
        let color = getDefaultColor(v.nodeType)
        if (isRenderLineDefault(v)) {
            color = v.colorValue || color
        }
        let isPin = false
        if (v.nodeType === k_renderLineType.milestone || v.nodeType === k_renderLineType.importMilestone || v.nodeType === k_renderLineType.payment || v.nodeType === k_renderLineType.expense) {
           isPin = true
        }
        let link = `/projects/${projectID}/payables`
        if(v.nodeType === k_renderLineType.expense){
            link = `${link}?type=sub&code=${v.lineID}`
        }else if(v.nodeType === k_renderLineType.payment){
            link = `${link}?type=main&code=${v.lineID}`
        }
        const isMoneyLine = v.nodeType === k_renderLineType.expense || v.nodeType === k_renderLineType.payment
        let bgcolor = isMoneyLine ? "bg-orange-50" : "bg-red-50"
        if (v.nodeType === k_renderLineType.milestone) {
            bgcolor = "bg-green-50"
        }
        let LineName = <span className="two-line-clamp">{v.lineName}</span>
        if (v.nodeType === k_renderLineType.importMilestone) {
            const res = parseProjectString(v.lineName)
            LineName = <div>
                {res.code && <div className="line-clamp-1">{res.code}</div>}
                {res.name && <div className="two-line-clamp">{res.name}</div>}
                {res.type && <div className="line-clamp-1">{res.type}</div>}
            </div>
        }
        return (
            <div key={v.lineID} className={clsx("h-[100px] pt-[6px] pr-2 flex flex-col items-center justify-center", bgcolor)}>
                <div className="flex relative group">
                    {isPin && (
                        <span className="shrink-0 text-[12px]" style={{color: color}}>
                            <PinSvg />
                        </span>
                        
                    )}
                    <Tooltip title={v.nodeType === k_renderLineType.milestone ? `${v.lineName} - (标准里程碑)` : v.lineName}>
                        <div className="text-white rounded-md text-xs text-center p-1 select-none cursor-pointer" onClick={() => onShowEditModal(v)} style={{ backgroundColor: color }}>
                            {LineName}
                            {v.nodeType === k_renderLineType.milestone && (
                                <div className="text-[12px] text-white text-center">(标准里程碑)</div>
                            )}
                        </div>
                    </Tooltip>
                    {(v.nodeType === k_renderLineType.payment || v.nodeType === k_renderLineType.expense) && (
                        <NavLink to={link} className="hidden group-hover:block absolute top-0 right-0 translate-x-full transition-colors duration-200">
                            <div className="text-[12px] text-white cursor-pointer ml-2 bg-black rounded-md px-1 hover:bg-gray-800">详情</div>
                        </NavLink>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div className="w-full flex flex-col" style={{ maxHeight: "calc(100vh - 140px)" }}>
            {messageContextHolder}
            <div className="flex items-center justify-between shrink-0">
                <div className="flex items-center text-xs relative" >
                    <span className="hover:bg-gray-200 rounded-full cursor-pointer px-2 py-1" onClick={() => onShowEditModal()}>+ 任务线管理</span>
                    <div className="text-[18px] flex items-center">
                        <span className={clsx("hover:bg-gray-200 cursor-pointer p-1 rounded-sm select-none", !hideLabel ? "text-blue-400" : "text-gray-600")} onClick={() => setHideLabel((v) => !v)}><ViewSvg /></span>
                        <span className={clsx("hover:bg-gray-200 cursor-pointer ml-2 p-1 rounded-sm select-none", !hideLinks ? "text-blue-400" : "text-gray-600")} onClick={() => setHideLinks((v) => !v)}><LinkSvg /></span>
                    </div>
                    <ImportMilestone onImportSuccess={() => { updateControlNodeLines() }} />
                </div>
                <div className="text-sm gap-1 flex justify-end">
                    <div className={clsx("w-[45px] h-[25px] rounded-sm flex items-center justify-center cursor-pointer hover:bg-blue-200", dateType === k_dateType.all && "bg-blue-200 text-blue-600")} onClick={() => setDateType(k_dateType.all)}>总览</div>
                    <div className={clsx("w-[25px] h-[25px] rounded-sm flex items-center justify-center cursor-pointer hover:bg-blue-200", dateType === k_dateType.week && "bg-blue-200 text-blue-600")} onClick={() => setDateType(k_dateType.week)}>周</div>
                    <div className={clsx("w-[25px] h-[25px] rounded-sm flex items-center justify-center cursor-pointer hover:bg-blue-200", dateType === k_dateType.month && "bg-blue-200 text-blue-600")} onClick={() => setDateType(k_dateType.month)}>月</div>
                    <div className={clsx("w-[25px] h-[25px] rounded-sm flex items-center justify-center cursor-pointer hover:bg-blue-200", dateType === k_dateType.season && "bg-blue-200 text-blue-600")} onClick={() => setDateType(k_dateType.season)}>季</div>
                    <div className={clsx("w-[25px] h-[25px] rounded-sm flex items-center justify-center cursor-pointer hover:bg-blue-200", dateType === k_dateType.year && "bg-blue-200 text-blue-600")} onClick={() => setDateType(k_dateType.year)}>年</div>
                    {todayPosition.current.show && (
                        <div className={clsx("h-[25px] px-2 rounded-sm flex items-center justify-center cursor-pointer hover:bg-blue-200")} onClick={scrollToToday}>今天</div>
                    )}
                </div>
            </div>

            <div className="w-full relative mt-4 flex flex-col flex-1 overflow-hidden">
                {scrollTimeLabel && (
                    <div className="absolute left-[100px] top-0 z-110" style={{ height: isHideMonthRow ? 35 : 70 }}>
                        <div className="absolute right-0 top-0 h-[35px] translate-x-full flex z-100 bg-white text-gray-500">
                            <span className="whitespace-nowrap">{scrollTimeLabel}</span>
                            <div style={{ width: 30, marginInlineEnd: -30, height: "100%", backgroundImage: "linear-gradient(90deg, #ffffff 20%, #fff0 100%)" }}></div>
                        </div>
                    </div>
                )}
                
                <div className={clsx("w-full relative flex flex-1", dateType === k_dateType.all ? "overflow-x-hidden overflow-y-auto" : "overflow-auto")} ref={gantEl} onScroll={onGantScroll}>
                    <div className="shrink-0 w-[100px] sticky left-0 z-200 bg-white h-fit min-h-[300px]">
                        <div className="sticky top-0 left-0 z-200 bg-white shadow-bottom pt-[2px]" style={{ height: isHideMonthRow ? 35 : 70 }}>
                            <Dropdown className="w-full"  popupRender={() => <PopLineSelect value={checkedIDs} list={renderList} onCheckedChange={onCheckLineChange} />} >
                                <div className={clsx("border border-solid py-1 px-1 flex items-center justify-center rounded-md text-xs  cursor-pointer", checkedRenderList.length === renderList.length ? "border-gray-300 text-gray-700 bg-white" : "bg-black text-white")}>任务线筛选<ArrowBottomSvg /></div>
                            </Dropdown>
                        </div>
                        <div className="relative mt-2">
                            {checkedRenderList.map((v: RenderLine, i) => renderLineName(v, i))}
                        </div>
                    </div>
                    <div className="flex-1 relative h-fit min-h-[300px]">
                        <div className="sticky top-0 left-0 z-50 bg-white shadow-bottom px-[20px]" style={{ width: dateType === k_dateType.all ? "100%" : calendar.contentW }}>
                            <div className="w-full">
                                {(dateType === k_dateType.all || dateType === k_dateType.year) ? (
                                    <Fragment>
                                        <div className="w-full relative h-[35px]">
                                            {calendar.years.map((v, i) => (
                                                <div key={i} className="text-gray-500 absolute whitespace-nowrap bg-white" style={{ left: dateType === k_dateType.all ? v.leftStr : v.leftCount * getDateWidth(dateType) }}>{v.year}年</div>
                                            ))}
                                        </div>
                                        {isHideMonthRow ? (<div></div>) : (
                                            <div className="flex h-[35px]">
                                                {calendar.months.map((v, i) => (
                                                    <div key={i} className={clsx("text-center text-gray-500 shrink-0 bg-white", dateType === k_dateType.all && "flex-1")} style={{ width: dateType === k_dateType.all ? "" : getDateWidth(dateType) }}>{v.month}月</div>
                                                ))}
                                            </div>
                                        )}
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <div className="w-full relative h-[35px]">
                                            {calendar.months.map((v, i) => (
                                                <div key={i} className="text-gray-500 absolute whitespace-nowrap" style={{ left: v.leftCount * getDateWidth(dateType) }}>{v.year}年{v.month}月</div>
                                            ))}
                                        </div>
                                        <div className="flex h-[35px]">
                                            {calendar.cols.map((v, i) => (
                                                <div key={i} className="text-center text-gray-500 shrink-0" style={{ width: getDateWidth(dateType) }}>{v}</div>
                                            ))}
                                        </div>
                                    </Fragment>
                                )}

                            </div>
                        </div>
                        <div className="relative mt-2" style={{ width: dateType === k_dateType.all ? "100%" : calendar.contentW }}>
                            {!hideLinks && (
                                <div className="absolute left-[20px] right-[20px] bottom-0" style={{ top: 0 }}>
                                    <LinkLines data={checkedRenderList} />
                                </div>
                            )}
                            
                            {checkedRenderList.map((v, i) => renderLine(v, i))}
                        </div>
                        {todayPosition.current.show && (
                            <div className="absolute bottom-0 w-px z-10 bg-blue-500" style={{ left: dateType === k_dateType.all ? todayPosition.current.leftStr : todayPosition.current.left, top: topHeight }}>
                                <div className="absolute w-[5px] h-[5px] rounded-full bg-blue-500 top-0 left-[-2px]"></div>
                            </div>
                        )}
                    </div>
                </div>
                {dateType === k_dateType.all && (
                    <Axis config={{ minDate: calendar.allStart, maxDate: calendar.allEnd }} value={dateRange} onChange={onDateRangeChange} />
                )}
                <div className="flex items-center justify-end gap-4 shrink-0">
                    <div className="flex items-center">
                        <span className=" inline-flex w-[14px] h-[14px] rounded-full border-2 bg-white border-gray-400 border-solid"></span>
                        <span className="ml-1 text-xs">主要节点</span>
                    </div>
                    <div className="flex items-center">
                        <div className="p-px rounded-full border-2 bg-white border-gray-700 border-solid">
                            <div className="w-[14px] h-[14px] rounded-full border bg-white border-gray-700 border-solid"></div>
                        </div>
                        <span className="ml-1 text-xs">出图节点</span>
                    </div>
                    {/* <div className="flex items-center">
                        <div className="p-px rounded-full border-2 bg-white border-gray-700 border-solid">
                            <div className="w-[7px] h-[20px] rounded-full border bg-white border-gray-700 border-solid"></div>
                        </div>
                        <span className="ml-1 text-xs">业主确认节点</span>
                    </div> */}
                </div>
            </div>
            <Edit visible={editVisible} allStatus={allStatus}
                forbidEdit={forbidEdit}
                onClose={() => setEditVisible(false)}
                onUpdate={updateControlNodeLines}
                list={nodeLines}
                paymentLines={contactsPaymentNodes}
                defaultID={defaultEditLineID}
                onShowFileModal={onShowDDSFileModalByNodeID}
            />
            <DDSFile node={curDdsNode.current} visible={ddsVisible} onClose={() => setDdsVisible(false)} />
            <PaymentExpenseLink forbidEdit={forbidEdit} visible={payExpenseLinkVisible} onClose={() => setPayExpenseLinkVisible(false)} onUpdate={refreshPaymentExpenseLinks} list={expenseLinesData} paymentLines={contactsPaymentNodes} defaultID={defaultEditLineID} />
        </div>
       

    )
}
export default Gant